module.exports = __webpack_public_path__ + "img/keytags-neotag-banner.2650ee1d.png";